export default "__VITE_ASSET__4364cb33__$_?nuxt_component=async&nuxt_component_name=SvgoFreebinancecoin__"